import './style.scss';
import React from 'react';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../Shared/components/controls/Button/index'

const CardExtensionLimit = (props) => {

  return (
    <div className="container">
      <div className="container__left">
        <div className='title'> 
          <Text field={props?.fields?.Title} />
        </div>
        <div className='subTitle'>
          <Text field={props?.fields?.Subtitle} />
        </div>
      </div>
      <div className="container__right">
        <Link  field={props?.fields?.Link}  className="button button-contained-primary"/>
      </div>
    </div>
  );
};

export default CardExtensionLimit;
